import * as React from 'react';
import {Typography, TypographyProps} from '@material-ui/core';
import styled from 'styled-components';
import {getDirectionStyles} from '../../utils/ThemeUtils';

const TypographyWithEllipsis = styled<React.FC<TypographyProps>>(Typography)`
    line-height: 20px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: ${p => getDirectionStyles(p.theme.muiTheme.direction)('left', 'right')};
    direction: ltr;
`;

export const TextEllipsis: React.FC<TypographyProps> = ({children, ...props}: TypographyProps) => (
    <TypographyWithEllipsis {...props}>{children}</TypographyWithEllipsis>
);
